module.exports = __webpack_public_path__ + "3ae119095c02e22b139995e9f602b9f6.png";